import {XauditModel} from '../xaudit.model';

export class FormattedLabelUserModel {
    FormattedLabelUserID: string = '';
    UserID: string = '';
    FullName: string = '';
}


export class LabelTokenModel {
    Token: string = '';
    value: string = '';
    Prefix: string = '';
    Sufix: string = '';
    isEndOfLine: boolean = false;
    TokenOrder  : number = 0;
}

export class cfgFormattedLabelTokenModel extends  XauditModel {
    enumFormattedLabelID: string = '';
    LabelFormatTokenID: string = '';
    LabelFormatID: string = '';
    TokenOrder: number;
    Prefix: string = '';
    TokenID: string = '';
    Sufix: string = '';
    isEndOfLine: boolean = false;
}


export class cfgLetterTokens extends  XauditModel{
    TokenID: string = '';
    Name: string = '';
    Token: string = '';
    Description: string = '';
    enumLetterTokenTypeId: string = '';
    enumTokenCategoryId: string = '';
    enumLetterTokenDataSourceId: string = '';
}
export class cfgFormattedLabelModel extends XauditModel{
  LabelFormatID: string = '';
  FormattedLabelUserId: string = '';
  enumFormattedLabelID: string = '';
}

